// extracted by mini-css-extract-plugin
export default {"dropdown":"HeaderUserMenu_dropdown__7DdcP"};